import { useEffect, useState } from 'react';
import { useRequestTypeApi } from '../../services/request-type-api';
/**
 * Gets information about the categories of request types in the current project. The object returned represents
 * mappings of request types to their categories, with request type IDs as the key, and their category as the value.
 *
 * If the API request is in progress, or `isServiceCMP` is false, `null` will be returned.
 *
 * This hook requires a parent `RequestTypeApiProvider` component to run in. Using this hook outside of the provider
 * wll raise an error at runtime.
 *
 * @param isServiceCMP - Whether the current project is a JSM CMP or not. If `false`, this hook will effectively be a
 * no-op, since request type categories are only a concept in JSM CMPs.
 * @returns An object containing mappings, or `null`.
 */
export const useRequestTypeCategories = ({
  isServiceCMP
}) => {
  const requestTypeApi = useRequestTypeApi();
  const [requestTypeCategoryMappings, setRequestTypeCategoryMappings] = useState(null);
  useEffect(() => {
    if (isServiceCMP) {
      requestTypeApi.getRequestTypeCategories().then(response => {
        setRequestTypeCategoryMappings(response.ticketTypes.reduce((prev, curr) => {
          var _response$practices$f;
          return {
            ...prev,
            [curr.id]: (_response$practices$f = response.practices.find(category => category.ticketTypes.includes(curr.id))) === null || _response$practices$f === void 0 ? void 0 : _response$practices$f.key
          };
        }, {}));
      });
    }
  }, [isServiceCMP, requestTypeApi]);
  return requestTypeCategoryMappings;
};